export default "__VITE_ASSET__55f56699__"